import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { debug } from 'console';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { WaitListModel } from '../../shared/models/WaitListModel';
import { LoaderService } from '../../shared/providers/loader.service';
import { ValidationService } from '../../shared/providers/validation.service';

@Component({
  selector: 'app-wait-list-users-list',
  templateUrl: './wait-list-users-list.component.html',
  styleUrls: ['./wait-list-users-list.component.css']
})
export class WaitListUsersListComponent implements OnInit {

  currentMenu = '';

  constructor(public Validation: ValidationService, private activatedRoute: ActivatedRoute, private http: HttpClient, public Authentication: AuthenticationService
    , protected loaderService: LoaderService
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });
  }

  dtOptions = {};
  dateFromRange: Date;
  dateToRange: Date;
  user: any;
  userLst: WaitListModel[];
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  isExport: boolean = false;
  rowCount = 0;
  searchText: string = '';
  IsLoading = false;

  ngOnInit(): void {
    this.user = this.Authentication.user;
    this.LoadUserData();
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  search() {
    this.dtElement.dtInstance.then(x => x.draw());
  }

  LoadUserData() {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[3, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          DateFrom: this.Validation.formatDatetoMMDDYYYY(this.dateFromRange),
          DateTo: this.Validation.formatDatetoMMDDYYYY(this.dateToRange),
          LoggedInUserId: this.user.Id,
          IsExport: this.isExport
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/user/waitlistusers/',
          dataTablesParameters, httpHeader
        ).subscribe(resp => {
          debugger;
          that.userLst = resp.data ? resp.data : [];
          if (this.rowCount == 0) {
            this.rowCount = resp.recordsTotal;
          }
          if (resp) {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            else {
              $(".dataTables_paginate.paging_full_numbers").show();
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          } else {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            $(".dataTables_paginate.paging_full_numbers").hide();
          }
          this.IsLoading = false;
        });
      },
      columns: [
      { data: 'Principal' },
      { data: 'CompanyName' },
      { data: 'Role' },
      { data: 'JoinedDate' },
      { data: 'State' },
      { data: 'City' }
      ]
    };
  }

  Export() {
    this.isExport = true;
    this.loaderService.display(true);
    const filter =
    {
      DateFrom: this.Validation.formatDatetoMMDDYYYY(this.dateFromRange),
      DateTo: this.Validation.formatDatetoMMDDYYYY(this.dateToRange),
      LoggedInUserId: this.user.Id,
      IsExport: true,
      SearchText:  this.searchText
    }
    const dataTablesParameters =
    {
      Extra_param: filter
    }

    const httpHeader = this.Validation.GetAuthHeader();
    this.http.post<string>(this.BASE_URL + '/user/waitlistusers/', dataTablesParameters, httpHeader).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Waitlist.xlsx');
      this.loaderService.display(false);
    });
    this.isExport = false;
  }

}
